import React from 'react';
import { isGhostingAsCn } from 'shared/utils/partnerUser';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import PartnerGhostBanner from 'shared/components/PartnerGhostBanner';
import { useCnWidgetAuth } from './useCnWidgetAuth';
import ReportFlow from './ReportFlow';
import CnTaskUpdates from './TaskUpdates';

const LoginPrompt: React.FC<{ onLogin: () => void; error: string }> = ({
  onLogin,
  error,
}) => (
  <div className="cn-login-container">
    <p className="cn-login-description">
      Automatic authentication failed. This usually happens when using incognito/private browsing mode or when third-party cookies are
      blocked.
    </p>
    <p className="cn-login-description">Please try one of the following:</p>
    <ul className="cn-login-list">
      <li>Use a regular browser window (not incognito/private)</li>
      <li>Enable third-party cookies in your browser settings</li>
      <li>Or click the button below to attempt manual login</li>
    </ul>
    <button onClick={onLogin} className="cn-login-button">
      Log in
    </button>
    {error && <p className="cn-login-error">{error}</p>}
  </div>
);

export default function CnWidget() {
  const { isLoading, error, showLoginButton, loginData, features, login } =
    useCnWidgetAuth();
  const ghostingAsCn = isGhostingAsCn();

  return (
    <div>
      {ghostingAsCn && <PartnerGhostBanner partner="cn" error={error} />}

      {isLoading && (
        <div className="cn-loading-container">
          <TrueImpactLoading />
        </div>
      )}

      {showLoginButton && <LoginPrompt onLogin={login} error={error} />}

      {!showLoginButton && !ghostingAsCn && error && (
        <p className="cn-login-error">{error}</p>
      )}

      {loginData &&
        (features.cnTaskUpdates ? (
          <CnTaskUpdates loginData={loginData} />
        ) : (
          <ReportFlow loginData={loginData} />
        ))}
    </div>
  );
}
